import { downloadAuthorizedFile } from './downloadBlob'

const ENDPOINTS = {
  hotel: '/admin/hotel/bookings/export',
  sarai: '/admin/sarai/bookings/export',
  service: '/admin/gurudwara-service-booking/export'
}

export function exportBookings ({ module, params }) {
  return downloadAuthorizedFile({
    url: ENDPOINTS[module],
    params,
    fallbackName: `${module}-bookings.xlsx`,
    fallbackError: 'Failed to export bookings'
  })
}
